import React, { useContext, useEffect, useRef, useState } from "react";
import "./webinarLandingPage.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import AbuotUs from "../../assets/images/new/media.png";
import ContavtImg from "../../assets/images/new/mainimg.png";
import Pitrupaksh from "../../assets/images/new/dhan.png";
import Abuotws from "../../assets/images/new/media-two.png";
import "swiper/css";
import "swiper/css/navigation";

import batuk from "../../assets/images/new/fav-removebg-preview.png";
import whyChooseUsImg from "../../assets/images/new/whyChooseUs.png";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";
import { ContactUSApi } from "../../ApiServices/NewsLettter/NewsLetterApi";
import { useNavigate } from "react-router-dom";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import LazySection from "../Home/LazySection";
import FAQSection from "../../Components/FAQSection/FAQ";
import mainLogo from "../../../src/assets/images/new/logo.png";
import { WebinarUser } from "../../ApiServices/Webinar/WebinarApi";
import { handleProceedRemainingPayment } from "../../Components/RazorPay/RazorPayFunction";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import axios from "axios";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { Helmet } from "react-helmet-async";
import RazorpayWebinarPaymentButton from "./RazorpayWebinarPaymentButton";
import ComingSoonModal from "../../Components/ComingSoonModal";
import { Modal } from "react-bootstrap";

const SatyanarayanaPoojaWebinar = () => {
  const { setLoader } = useContext(LoaderContext);
  const [showModal, setShowModal] = useState(false);

  const slides = [
    {
      image: "../../assets/images/new/aboutPageImg.png",
      category: "Webinar Speaker",
      title: "Pandit Rajesh Guruji ",
      text: "inspiring minds with ancient wisdom and modern insights to lead a balanced and purposeful life.",
      progress: "85%",
      goal: "$23,000 Goals",
      donated: "$9,000 Donate",
      color: "#ffa415",
      shape: "assets/images/shapes/d-shape-1.png",
    },
    {
      image: "assets/images/donation/donation-1-2.jpg",
      category: "Webinar Speaker",
      title: "Pandit Rajesh Guruji ",
      text: "inspiring minds with ancient wisdom and modern insights to lead a balanced and purposeful life.",
      progress: "80%",
      goal: "$13,000 Goals",
      donated: "$5,000 Donate",
      color: "#ff5528",
      shape: "assets/images/shapes/d-shape-2.png",
    },
    // Add more slides here if needed
  ];
  const [Action, setAction] = useState([]);
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(null);
  const navigate = useNavigate();
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);
  const [contactData, setContactData] = useState({
    email: null,
    LastName: null,
    email: null,
    mobileNumber: null,
    Message: null,
  });
  const [contactUsMsg, setContactUsMsg] = useState(false);
  const [error, setError] = useState(false);
  const [verified, setVerified] = useState(null);

  const hasShownModal = useRef(false); // Ensures modal shows only once
  const scrollStarted = useRef(false); // Tracks if user really started scrolling

  const metaDataDetails = {
    MetaTitle:
      "Book Satyanarayana Pooja  Online for Prosperity | Myomnamo",
    MetaDescription:
      "Invite divine blessings of abundance and fortune with the Satyanarayana Pooja . Book your online puja with trusted Myomnamo pandits for success and prosperity.",

    CanonicalTag: "https://www.myomnamo.com/services/book-puja/dhana-akarshana-homam",
  };

 useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowModal(true);
      } else {
        setShowModal(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

 
  const setInitialData = () => {
    setError(false);
    setContactData((prev) => ({
      ...prev,
      fullName: "",
      LastName: "",
      email: "",
      mobileNumber: "",
      Message: "",
    }));
  };

  //     const templateParams = {
  //       Name: params.name,
  //       email: params.email,
  //       "Mobile Number": params.mobileNo,
  //       message: params.message,
  //       //   to_name: "Velvet Admin",
  //       //   from_name: "Velvet mail service",
  //       //   receiver_email: "velvetgps@gmail.com",
  //     };

  //     emailjs
  //       .send(
  //         "service_wp19bkh", // Service ID
  //         "template_b9wrsrm", // Template ID
  //         templateParams, // Template Parameters
  //         "e5YUU5XlmWckFjZk_" // Public Key
  //       )
  //       .then(
  //         () => {
  //           
  //           setShowThanksModal(true);
  //         },
  //         (error) => {
  //           
  //         }
  //       );
  //   };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    let { id, value } = e.target;

    if (id === "fullName" || id === "lastName") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }
    if (id === "mobileNumber") {
      value =
        value.charAt(0) >= "6" ? value.replace(/\D/g, "").slice(0, 10) : ""; // Only keep digits and slice to 10 digits
    }

    setContactData((prev) => ({ ...prev, [id]: value }));
  };

  const handleRazorpayPayment = async () => {
    let orderIDReturned = null;
    setLoader(true);
    const PlaceOrderResponse = await handleProceedRemainingPayment("51");


    if (PlaceOrderResponse?.status === 1) {
      axios
        .post(`${BaseUrl}/Webinar/WebinarUser`, {
          Name: contactData.fullName,
          EmailID: contactData.email,
          WhatsappNumber: contactData.mobileNumber,
          WebinarFee: 51,
          PaymentStatus: true,
          TransactionID: PlaceOrderResponse?.razorpay_payment_id,
        })
        .then((res) => {
          if (res) {
            console.log(res);

            orderIDReturned = res.data.ID;
            setLoader(false);
            // navigate("/thank-you", {
            //   state: { moduleName: "WebinarPage" },
            // });
            setInitialData();
            setShowComingSoonModal(true);
          }
        });
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false);
      alert("Payment Failed !");
    }
  };

  const HandleJoinNowClicked = () => {
    window.open("https://rzp.io/rzp/dhana-akarshana-homam", "_blank");
  };


 

  return (
    <>
      <Helmet>
        <title>{metaDataDetails?.MetaTitle}</title>
        <meta name="description" content={metaDataDetails?.MetaDescription} />
        <link rel="canonical" href={metaDataDetails?.CannonicalLink} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={metaDataDetails?.OpenGraphTag} />
        <meta
          property="og:description"
          content="Celebrate Ganeshotsav with devotion & knowledge. Join our webinar to learn step-by-step Ganesh Puja rituals & traditions."
        />
        <meta property="og:title" content="Book Satyanarayana Pooja  Online for Prosperity | Myomnamo" />
        <meta property="og:description" content="Invite divine blessings of abundance and fortune with Satyanarayana Pooja . Book your online puja with trusted Myomnamo pandits for success and prosperity." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.myomnamo.com/services/book-puja/dhana-akarshana-homam" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:image" content="h" />
        <meta property="og:image:alt" content="Satyanarayana Pooja " />


        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaDataDetails?.MetaTitle} />
        <meta
          name="twitter:description"
          content={metaDataDetails?.MetaDescription}
        />

        <script>
          {`
            !function(f,b,e,v,n,t,s){
              if(f.fbq) return; 
              n=f.fbq=function(){n.callMethod ? 
              n.callMethod.apply(n,arguments) : n.queue.push(arguments)};
              if(!f._fbq) f._fbq=n;
              n.push=n; n.loaded=!0; n.version='2.0';
              n.queue=[]; t=b.createElement(e); t.async=!0;
              t.src=v; s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '24982247501377559');
            fbq('track', 'PageView');
          `}
        </script>
        <noscript>
          {`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=24982247501377559&ev=PageView&noscript=1"/>`}
        </noscript>
      </Helmet>

      <header className="navbar">
        <div className="container">
          <div className="navbar-logo">
            <img src={mainLogo} alt="Logo" />
          </div>
        </div>
      </header>

      <section className="pitru-section py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Content */}
            <div
              className="col-lg-7 mb-4 mb-lg-0 wow fadeInLeft pitru-left"
              data-wow-delay="100ms"
            >
              <div className="pitru-content">
                {/* Title */}
                <h3 className="pitru-title">Satyanarayana Pooja </h3>
                <p className="pitru-subtitle">
                  This Homam is particularly beneficial for individuals seeking
                  financial improvement, career advancement, and spiritual
                  growth. It's also recommended for those facing financial
                  difficulties, business challenges, or personal issues. By
                  performing Swarna Akarshana Bhairava Homam, individuals can
                  experience transformative benefits, including
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    <li style={{ marginBottom: "8px" }}>
                      <b>1. Manifesting Desires : </b>Manifesting desires and
                      achieving goals
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      <b>2. Overcoming Obstacles :</b> Removing obstacles and
                      challenges in life
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      <b>3. Divine Blessings : </b>Receiving divine blessings
                      for comprehensive well-being.
                    </li>
                  </ul>
                </p>

                {/* Details */}
                <div className="pitru-info-boxes">
                  {/* Details Box */}
                  <div className="pitru-details-card">
                    <ul
                      style={{
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      <li
                        style={{
                          display: "block",
                          alignItems: "flex-start",
                          marginBottom: "8px",
                          lineHeight: 1.5,
                          fontSize: "16px",
                          color: "black",
                        }}
                      >
                        <i
                          className="fa-solid fa-language"
                          style={{
                            color: "#ef9b23",
                            marginRight: "8px",
                            fontSize: "18px",
                            minWidth: "20px",
                            marginTop: "3px",
                          }}
                        ></i>
                        <span
                          style={{
                            color: "#a52444",
                            fontWeight: 600,
                            marginRight: "4px",
                            fontSize: "16px",
                          }}
                        >
                          Homam name :
                        </span>
                        Satyanarayana Pooja .
                      </li>

                      <li
                        style={{
                          display: "block",
                          alignItems: "flex-start",
                          marginBottom: "8px",
                          lineHeight: 1.5,
                          fontSize: "16px",
                          color: "black",
                        }}
                      >
                        <i
                          className="fa-solid fa-calendar"
                          style={{
                            color: "#ef9b23",
                            marginRight: "8px",
                            fontSize: "18px",
                            minWidth: "20px",
                            marginTop: "3px",
                          }}
                        ></i>
                        <span
                          style={{
                            color: "#a52444",
                            fontWeight: 600,
                            marginRight: "4px",
                            fontSize: "16px",
                          }}
                        >
                          Date :
                        </span>
                        29 October 2025
                      </li>

                      <li
                        style={{
                          display: "block",
                          alignItems: "flex-start",
                          marginBottom: "8px",
                          lineHeight: 1.5,
                          fontSize: "16px",
                          color: "black",
                        }}
                      >
                        <i
                          className="fa-solid fa-clock"
                          style={{
                            color: "#ef9b23",
                            marginRight: "8px",
                            fontSize: "18px",
                            minWidth: "20px",
                            marginTop: "3px",
                          }}
                        ></i>
                        <span
                          style={{
                            color: "#a52444",
                            fontWeight: 600,
                            marginRight: "4px",
                            fontSize: "16px",
                          }}
                        >
                          Time :
                        </span>
                        10.30 am to 01.00 pm
                      </li>

                      <li
                        style={{
                          display: "block",
                          alignItems: "flex-start",
                          marginBottom: "8px",
                          lineHeight: 1.5,
                          fontSize: "16px",
                          color: "black",
                        }}
                      >
                        <i
                          className="fa-solid fa-hourglass-half"
                          style={{
                            color: "#ef9b23",
                            marginRight: "8px",
                            fontSize: "18px",
                            minWidth: "20px",
                            marginTop: "3px",
                          }}
                        ></i>
                        <span
                          style={{
                            color: "#a52444",
                            fontWeight: 600,
                            marginRight: "4px",
                            fontSize: "16px",
                          }}
                        >
                          Temple :
                        </span>
                        Swarna akarshana bairavar temple, Kumbakonam.
                      </li>
                      <li
                        style={{
                          display: "block",
                          alignItems: "flex-start",
                          marginBottom: "8px",
                          lineHeight: 1.5,
                          fontSize: "16px",
                          color: "black",
                        }}
                      >
                        <i
                          className="fa-solid fa-video"
                          style={{
                            color: "#ef9b23",
                            marginRight: "8px",
                            fontSize: "18px",
                            minWidth: "20px",
                            marginTop: "3px",
                          }}
                        ></i>

                        <span
                          style={{
                            color: "#a52444",
                            fontWeight: 600,
                            marginRight: "4px",
                            fontSize: "16px",
                          }}
                        >
                          Mode :
                        </span>
                        via live streaming, and we will provide access to the recorded video afterwards.
                      </li>

                    </ul>
                  </div>

                  {/* Price Box */}
                  <div className="pitru-price-card">
                    <span className="pitru-price-label">Booking Price</span>
                    <span className="pitru-price" style={{ fontSize: "32px" }}>
                      ₹ 501
                    </span>
                  </div>
                </div>
                <button
                  type="submit"
                  onClick={() => HandleJoinNowClicked()}
                  className="careox-btn pitru-button"
                >
                  <i
                    className="fa-solid fa-user-plus"
                    style={{ marginRight: "8px" }}
                  ></i>
                  <span className="pitrupakshabut">Book Your Puja Now</span>
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-lg-5 pitru-right wow fadeInRight">
              <div className="pitru-image">
                <img src={Pitrupaksh} alt="Pitru Paksha Ritual" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="shraddha-section">
        <div className="shraddha-heading text-center">
          <h2 className="main-heading Pitrupaksha">
            Benefits of Satyanarayana Pooja 
          </h2>
          <p className="sub-heading pitrru-subheading">
            Swarna Akarshana Bhairava Homam is a powerful Vedic ritual that offers numerous benefits, including:
          </p>
        </div>

        <div className="container shraddha-container">
          {/* Card 1 */}
          <div className="puja-card">
            <h4 className="puja-title">Financial Benefits</h4>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li style={{ marginBottom: "6px", fontSize: "16px" }}>
                <strong>1. Attracting Wealth:</strong> Attracts wealth and financial abundance, removing financial blockages and obstacles
              </li>
              <li style={{ marginBottom: "6px", fontSize: "16px" }}>
                <strong>2. Removing Debt:</strong> Helps settle debts and loans quickly
              </li>
              <li style={{ marginBottom: "6px", fontSize: "16px" }}>
                <strong>3. Improving Financial Stability:</strong> Enhances financial stability, ensuring consistent income flow and managing expenses effectively
              </li>
            </ul>
          </div>

          {/* Card 2 */}
          <div className="puja-card">
            <h4 className="puja-title">Personal Benefits</h4>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li style={{ marginBottom: "6px", fontSize: "16px" }}>
                <strong>1. Improved Relationships:</strong> Fosters harmony among family members, friends, and colleagues
              </li>
              <li style={{ marginBottom: "6px", fontSize: "16px" }}>
                <strong>2. Health and Vitality:</strong> Supports overall health and vitality, enhancing energy levels
              </li>
              <li style={{ marginBottom: "6px", fontSize: "16px" }}>
                <strong>3. Personal Growth:</strong> Enhances self-confidence, fosters a positive mindset, and helps achieve personal goals
              </li>
            </ul>
          </div>

          {/* Card 3 */}
          <div className="puja-card">
            <h4 className="puja-title">Career Benefits</h4>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li style={{ marginBottom: "6px", fontSize: "16px" }}>
                <strong>1. Career Advancement:</strong> Supports career growth, promotions, and job stability
              </li>
              <li style={{ marginBottom: "6px", fontSize: "16px" }}>
                <strong>2. Business Success:</strong> Enhances business prospects, attracts clients and customers, and ensures smooth operations
              </li>
            </ul>
          </div>

          {/* Card 4 */}
          <div className="puja-card">
            <h4 className="puja-title">Spiritual Benefits</h4>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li style={{ marginBottom: "6px", fontSize: "16px" }}>
                <strong>1. Spiritual Growth :</strong> Spiritual Growth
              </li>
              <li style={{ marginBottom: "6px", fontSize: "16px" }}>
                <strong>2. Protection :</strong> Provides protection from negative energies, misfortunes, and hardships
              </li>
            </ul>
          </div>

          <div className="button-wrapper">
            <button
              type="submit"
              onClick={() => HandleJoinNowClicked()}
              className="careox-btn cta-pitrupakshaone"
              style={{ marginTop: "0px" }}
            >
              <i className="fa-solid fa-user-plus" style={{ marginRight: "8px" }}></i>
              <span className="pitrupakshabutone">Reserve Your Spot for the Homam</span>
            </button>
          </div>
        </div>
      </section>


      {/* <section
        className="shraddha-section cta-pitrupaksha"
        style={{ marginBottom: "60px" }}
      >
        <div className="shraddha-heading text-center">
          <h2 className="main-heading Pitrupaksha pitrupaksha-headingcta mobile-alignament">
            मर्यादित जागा! आताच नोंदणी करा
          </h2>
          <div className="button-wrapper">
            <button
              type="submit"
              onClick={() => HandleJoinNowClicked()}
              className="careox-btn cta-pitrupakshaone"
            >
              <i
                className="fa-solid fa-user-plus"
                style={{ marginRight: "8px" }}
              ></i>
              <span className="pitrupakshabutone">आता नोंदणी करा</span>
            </button>
          </div>
        </div>
      </section> */}

      <footer className="footer">
        <div className="footer-container">
          {/* Left Side - Logo + Tagline */}
          <div className="footer-left">
            <img src={mainLogo} alt="Logo" className="footer-logo" />
            <p className="footer-tagline">Enhance Your Spiritual Journey</p>
          </div>

          {/* Right Side - Contact Info */}
          <div className="footer-right">
            <h3 className="footer-heading">Contact</h3>
            <p>
              <i className="fa-solid fa-phone" style={{ marginRight: "8px" }}></i>
              <a href="tel:+919119555461" style={{ color: "inherit", textDecoration: "none" }}>
                +91 91195 55461
              </a>
            </p>
            <p>
              <i className="fa-solid fa-envelope" style={{ marginRight: "8px" }}></i>
              <a href="mailto:info@myomnamo.com" style={{ color: "inherit", textDecoration: "none" }}>
                info@myomnamo.com
              </a>
            </p>


            {/* Social Icons */}
            <div className="footer-social">
              <a href="#">
                <i className="fa-brands fa-facebook"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <p className="footer-bottomlink">
            © 2025 Myomnamo. All rights reserved.
          </p>
        </div>

        {/* Floating Buttons */}
        <div className="floating-buttons">
          {showModal && (
            <a
              href="#top"
              onClick={() => setShowModal(false)}
              className="scroll-top"
            >
              <i className="fa-solid fa-arrow-up"></i>
            </a>
          )}


          <a
            href="https://api.whatsapp.com/send/?phone=919975267711"
            target="_blank"
            className="whatsapp"
          >
            <i className="fa-brands fa-whatsapp"></i>
          </a>
        </div>
      </footer>

      <ComingSoonModal
        show={showComingSoonModal}
        onClose={() => setShowComingSoonModal(false)}
        moduleName="e-webinar"
      />
    </>
  );
};
export default SatyanarayanaPoojaWebinar;
